import { useSelector } from "react-redux";

const AccessibilityNotification = () => {
    const a11yNotificationText = useSelector(
        (state) => state.a11y.a11yNotificationText
    );
    return (
        <div
            id="a11yNotification"
            className="a11y"
            role="alert"
            aria-live="polite"
        >
            {a11yNotificationText}
        </div>
    );
};

export default AccessibilityNotification;
